export default "__VITE_ASSET__B0C08pRL__"